import { Popper } from '@mui/material';
import { createTheme, adaptV4Theme } from '@mui/material/styles';
import { ToggleButtonClassKey } from '@mui/material/ToggleButton';

const primary = '#e6ac00';
const primaryLight = "#ebbc33a1";
const secondary = '#575757';
const spacing = 8;

const theme = createTheme({
    spacing: spacing,
    palette: {
        primary: {
            main: primary,
            light: primaryLight
        },
        secondary: {
            main: secondary,
        }
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            color: secondary,
            fontSize: '35px',
            // paddingBottom: spacing * 1
        },
        h2: {
            color: secondary,
            fontSize: '1.5rem',
            paddingBottom: spacing * 1
        },
        h3: {
            fontWeight: 400,
            fontSize: '20px',
            paddingBottom: spacing * 1,
        }
    },
    components: {
        MuiTextField: {
            defaultProps: {
                fullWidth: true
            }
        },
        MuiFormControl: {
            defaultProps: {
                size: 'small'
            },
            styleOverrides: {
                root: {
                    minWidth: '120px',
                }
            }
        },
        MuiLink: {
            defaultProps: {
                underline: 'hover',
            },
        },
        MuiGrid: {
            styleOverrides: {
                item: {
                    padding: spacing
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    marginRight: spacing * 2,
                    '&:last-child': {
                        marginRight: 0
                    }
                }
            }
        },
        MuiButtonGroup: {
            styleOverrides: {
                groupedHorizontal: {
                    marginRight: 0
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    minWidth: 140
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: spacing * 1.2
                },
                head: {
                    fontWeight: 600
                }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    paddingTop: spacing * 2,
                    paddingBottom: spacing * 2,
                    paddingLeft: spacing * 3,
                    paddingRight: spacing * 3,
                }
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: spacing * 2,
                    paddingRight: spacing * 2,
                    '&:first-of-type': {
                        paddingTop: 0
                    }
                }
            }
        },
        MuiDialogContentText: {
            styleOverrides: {
                root: {
                    marginBottom: 0,
                    paddingLeft: spacing,
                    paddingRight: spacing
                }
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                PopperComponent(props) { return (<Popper {...props} placement="bottom-start" />) },
            },
            styleOverrides: {
                popper: {
                    minWidth: '25%'
                }
            }
        }
    }
})

declare module '@mui/material/styles/overrides' {
    export interface ComponentNameToClassKey {
        MuiToggleButton: ToggleButtonClassKey;
    }
}


export default theme